import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store/create-store';
import { BioState, IBioData } from 'store/bio/types';

export const getBioState = (state: RootState): BioState => state.bio;

export const getBioData = createSelector(
  [getBioState],
  (state: BioState): IBioData[] => state?.data
);
